import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import Cookies from 'js-cookie';
import { Print } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import moment from 'moment';

type SchedulePrintButtonProps = {
    selectedDate: Date | null;
};
const SchedulePrintButton: FC<SchedulePrintButtonProps> = ({ selectedDate }: SchedulePrintButtonProps) => {
    const { t: translate } = useTranslation(['transport']);
    const [isLoading, setIsLoading] = useState(false);

    const printSchedule = async () => {
        if (selectedDate) {
            setIsLoading(true);
            const uri = `${CONSTANTS.DOC_API_URI}/transport/transport-schedule/${moment(selectedDate).format('YYYY-MM-DD')}`;
            const res = await fetch(uri, {
                headers: {
                    authorization: Cookies.get(CONSTANTS.TOKEN_KEY) || '',
                },
            });
            if (!res.ok) {
                throw new Error((await res.json()).message);
            }
            const blob = await res.blob();
            return handleDownload(`Transport-${moment(selectedDate).format('YYYY-MM-DD')}.pdf`, blob);
        }
    };

    const handleDownload = (filename: string, fileData: Blob): void => {
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(fileData);
        downloadLink.download = filename;
        downloadLink.target = '_blank';
        downloadLink.click();
        setIsLoading(false);
    };

    return (
        <LoadingButton
            loading={isLoading}
            loadingPosition="start"
            startIcon={<Print />}
            onClick={() => printSchedule()}
        >
            {translate('transport:PRINT')}
        </LoadingButton>
    );
};

export default SchedulePrintButton;
